module.exports = __webpack_public_path__ + "static/media/activity5.600aa03d.png";